// frontend/src/components/matching/CanSupplyTable.jsx
import MatchedFieldsBadges from "./MatchedFieldsBadges";
import PageLink from "./PageLink";
import SourceLink from "./SourceLink";
import {
  SpecsCell, ScoreBadge, EditedBadge, ReqQtyCell, EditProductCell, EditToggleCell,
} from "./cells";
import "./Matching.css";

// Artikelnummer + Product + Score are replaced by the product search while editing.
const EDIT_COLSPAN = 3;

export default function CanSupplyTable({ results, corrections = {}, editingRow = null, onEditRow, onCorrect, documentUrl = "", documentName = "", catalogProducts = [] }) {
  if (!results.length) {
    return <p className="ds-empty">No positions could be matched to the catalog.</p>;
  }
  return (
    <div className="mt-section">
      <SourceLink url={documentUrl} name={documentName} />
      <div className="ds-table-wrap">
        <table className="ds-table">
          <thead>
            <tr>
              <th>Position</th>
              <th>LV title</th>
              <th>Specs</th>
              <th>Artikelnummer</th>
              <th>Product</th>
              <th>Score</th>
              <th>Req. qty</th>
              <th>Matches</th>
              <th>Page</th>
              {onEditRow && <th><span className="ds-visually-hidden">Edit</span></th>}
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => {
              const lv = r.lv_item;
              const pos = lv.position || String(i);
              const correctedProd = corrections[pos];
              const bm = r.best_match;
              const shown = correctedProd || bm?.product;
              const isEditing = editingRow === pos;
              return (
                <tr key={i} className={`mt-row-supply${correctedProd ? " mt-row-corrected" : ""}`}>
                  <td className="mt-pos">{lv.position || "—"}</td>
                  <td className="mt-title">{lv.title || "—"}</td>
                  <SpecsCell specs={lv.specs} />
                  {isEditing ? (
                    <EditProductCell
                      colSpan={EDIT_COLSPAN}
                      catalogProducts={catalogProducts}
                      onSelect={(product) => { if (onCorrect) onCorrect(pos, product); }}
                      onCancel={() => onEditRow(null)}
                    />
                  ) : (
                    <>
                      <td className="mt-artnr">{shown?.artikelnummer || "—"}</td>
                      <td className="mt-product">
                        {shown?.name || "—"}
                        {correctedProd && <EditedBadge />}
                      </td>
                      <td className="mt-nowrap">{bm && <ScoreBadge score={bm.score} />}</td>
                    </>
                  )}
                  <ReqQtyCell result={r} />
                  <td><MatchedFieldsBadges matchedFields={bm?.matched_fields} /></td>
                  <td className="mt-page">
                    {lv.page_number != null
                      ? <PageLink url={documentUrl} page={lv.page_number} />
                      : "—"}
                  </td>
                  {onEditRow && (
                    <EditToggleCell isEditing={isEditing} title="Edit match" onEdit={() => onEditRow(pos)} />
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
